import type { ComponentGraphGroup, GroupHeaderLayout } from '@ardoq/graph';
import type { INode } from '@ardoq/yfiles';
import { isTruthy } from '@ardoq/common-helpers';
import { layoutGroupHeaderLabels } from './layoutGroupHeaderLabels';
import { UrlLabelStyle } from 'yfilesExtensions/styles/UrlLabelStyle';
import {
  GROUP_SUB_LABEL_KIND,
  OPEN_GROUP_OTHER_LABEL_KIND,
  getGroupHeaderLabelKind,
} from 'tabview/blockDiagram/view/yFilesExtensions/modernized/groupLabels/groupHeaderLabelKind';
import { INVISIBLE_SEPARATOR } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import { safeGetRepresentationDataFromINodeTag } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/modernizedBlockDiagramRepresentationData';

const layoutGroupHeader = (node: INode): GroupHeaderLayout | null => {
  const {
    labels,
    tag,
    layout: { width: nodeWidth },
  } = node;
  const graphGroup = tag as ComponentGraphGroup | null;
  if (!graphGroup || nodeWidth <= 1 || graphGroup.collapsed) {
    return null;
  }
  const mainLabel = labels.at(0)?.text ?? '';
  const subLabel =
    labels.find(
      ({ style }) => getGroupHeaderLabelKind(style) === GROUP_SUB_LABEL_KIND
    )?.text ?? null;
  const otherLabels =
    labels
      .find(
        ({ style }) =>
          getGroupHeaderLabelKind(style) === OPEN_GROUP_OTHER_LABEL_KIND
      )
      ?.text.split(INVISIBLE_SEPARATOR)
      .filter(isTruthy) ?? [];
  const hasUrlFields = Boolean(
    labels.find(({ style }) => style === UrlLabelStyle.Instance)
  );
  return layoutGroupHeaderLabels({
    mainLabel,
    subLabel,
    otherLabels,
    nodeWidth,
    hasUrlFields,
    hasRepresentationData: Boolean(
      safeGetRepresentationDataFromINodeTag(graphGroup)
    ),
  });
};

export { layoutGroupHeader };
